import { useAuth } from "@clerk/clerk-react";
import { useMemo } from "react";
import { setAuthInterceptor } from "@/lib/api";

interface AuthProviderProps {
	children: React.ReactNode;
}

export const AuthProvider = (props: AuthProviderProps) => {
	const { children } = props;
	const { getToken } = useAuth();

	const ready = useMemo(() => {
		setAuthInterceptor(getToken);
		return true;
	}, [getToken]);

	if (!ready) {
		return null;
	}

	return <>{children}</>;
};
